import React from 'react';
import { IconArrowRight16, Text, Box } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import { Link } from '@stitch-fix/sf-next';
import { CloudinaryImageWrapper, type CloudinaryImageFields } from '../CloudinaryImageWrapper';
import styles from './style.module.scss';
export interface PromoBannerProps {
  images: CloudinaryImageFields[];
  headline: string;
  content: string;
  ctaText: string;
  ctaHref: string;
  variant?: 'teal' | 'dark-teal' | 'charcoal' | 'coastal' | 'light-gray';
}
export const PromoBanner = ({
  headline,
  content,
  images,
  ctaText,
  ctaHref,
  variant = 'dark-teal'
}: PromoBannerProps) => {
  return <Box className={classNames(styles.bannerContainer, styles[variant])} data-testid="promo-banner">
      <Box className={styles.imageContainer}>
        {images.map((image, index) => {
        return <Box key={image.src} className={classNames(styles.image, {
          [styles.firstItem]: index === 0
        })}>
              <CloudinaryImageWrapper alt={image.alt} src={image.src} aspectRatio={image.aspectRatio} lazy objectFit="cover"
          // these breakpoints are based
          // on the end behavior from the previous
          // responsive image component, so they might seem a
          // bit arbitrary
          sources={{
            sm: 560,
            md: 900,
            lg: 350
          }} cloudinaryAsset={image.cloudinaryAsset} sizes={[{
            minWidth: 0,
            fluidWidth: 100
          }, {
            minWidth: 900,
            staticWidth: 340
          }]} imageProps={{
            loading: 'lazy'
          }} />
            </Box>;
      })}
      </Box>
      <Box p="1.5rem">
        <Text setting="title-large" spacingBottom>
          {headline}
        </Text>
        <Text setting="body-medium-fixed" spacingBottom>
          {content}
        </Text>
        {ctaHref && <Link variant="inherit" size="tertiary" href={ctaHref} endIcon={<IconArrowRight16 />}>
            {ctaText}
          </Link>}
      </Box>
    </Box>;
};